module.exports = __webpack_public_path__ + "static/media/stock24.6a7f4d28.jpg";